(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // --header-height csak a connectedCallback-kor mért egyszeri érték volt, nem követte
      // a header tényleges magasságváltozásait (scroll-ös glass-shrink, logó kép késői
      // betöltése, announcement bar magasságváltozás) - ezért a fixen pozícionált predictive
      // search (1200px+, top: var(--header-height)) időnként a régi (kisebb) értékre
      // pozícionálva belecsúszott a search bar-ba. ResizeObserver mindig friss értéket ír.
      new ResizeObserver(() => this.setHeaderHeight()).observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
        
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function positionHeaderSearchModal() {
    var details = document.querySelector('.header__search details');
    if (!details || !details.hasAttribute('open') || window.innerWidth < 1200) return;
    var caret = document.querySelector('.header__inline-menu .icon-caret');
    var rightBoundary = document.querySelector('.desktop-localization-wrapper')
      || document.querySelector('.header__icon--account')
      || document.querySelector('.header__icon--cart');
    var anchor = document.querySelector('.header__search');
    var modal = document.querySelector('.search-modal');
    if (!caret || !rightBoundary || !anchor || !modal) return;
    var anchorLeft = anchor.getBoundingClientRect().left;
    var leftOffset = 40; /* -4rem (root font-size 10px) eltolás balra a caret-hez képest */
    var caretRect = caret.getBoundingClientRect();
    var navTextEl = caret.closest('summary') ? caret.closest('summary').querySelector('span') : null;
    /* sose fedje a nav szövegét (pl. "Collections"), a caret nyíl ikont igen */
    var textSafeFloorVP = navTextEl ? navTextEl.getBoundingClientRect().right : caretRect.left;
    var rightShift = 20; /* 2rem jobbra összesen (root font-size 10px) */
    var desiredLeftVP = caretRect.right - leftOffset;
    var leftVP = Math.max(desiredLeftVP, textSafeFloorVP) + rightShift;
    var left = leftVP - anchorLeft;
    var width = rightBoundary.getBoundingClientRect().left - leftVP;
    modal.style.setProperty('--search-modal-left', left + 'px');
    modal.style.setProperty('--search-modal-width', width + 'px');
  }

  var headerSearchDetails = document.querySelector('.header__search details');
  if (headerSearchDetails) headerSearchDetails.addEventListener('toggle', positionHeaderSearchModal);
  window.addEventListener('resize', positionHeaderSearchModal);

  } catch(e) { console.error(e); }
})();
})();
